import styled from 'styled-components';

export const MoreButton = styled.div`
  float: right;
  height: 100%;
  color: #333;
  font-size: 11px;
  padding: 0 15px;
  line-height: 37px;

  &:after {
    display: inline-block;
    vertical-align: middle;
    content: '';
    margin-left: 8px;
    width: 7px;
    height: 12px;
    background: url('/images/sp_layout.png') no-repeat -215px -190px;
    background-size: 350px 350px;
  }
`;
